module.exports = __webpack_public_path__ + "img/spark.5972b1dc.png";